import Classroom from "../models/Classroom";
export default class ClassroomService {
    mapInterfaceToModel(input, repositories = null) {
        let classroom = new Classroom();
        classroom.id = input.id;
        input.name === null ? classroom.name = "Empty" : classroom.name = input.name;
        return classroom;
    }
}
